if (process.env.NODE_ENV === 'production') {
    module.exports = require('./themeswitcher.prod');
} else {
    module.exports = require('./themeswitcher.dev');
}
